(function () {
  'use strict';

  /* ---------- gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-gal-track]');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-thumb]'));
    var idxEl = gal.querySelector('[data-gal-index]');
    var totalEl = gal.querySelector('[data-gal-total]');
    if (!track) return;

    var slides = track.children.length;
    if (totalEl) totalEl.textContent = slides;

    function setActive(i) {
      if (idxEl) idxEl.textContent = i + 1;
      thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(slides - 1, i)));
        ticking = false;
      });
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-gal-thumb'), 10);
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });
  });

  /* ---------- accordions ---------- */
  document.querySelectorAll('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) {
        if (open) panel.removeAttribute('data-open');
        else panel.setAttribute('data-open', '');
      }
    });
  });

  /* ---------- bundle picker + subscription ---------- */
  var form = document.querySelector('[data-buy-form]');
  var qtyInput = document.querySelector('[data-qty-input]');
  var variantInput = document.querySelector('[data-variant-input]');
  var planInput = document.querySelector('[data-selling-plan-input]');
  var subToggle = document.querySelector('[data-bnd-sub-toggle]');
  var opts = Array.prototype.slice.call(document.querySelectorAll('[data-bnd-opt]'));
  var atcLabel = document.querySelector('[data-atc-label]');
  var stickyPack = document.querySelector('[data-sticky-pack]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var priceNow = document.querySelector('[data-price-now]');
  var priceWas = document.querySelector('.price__was');
  var priceSave = document.querySelector('.price__save');
  var priceUnit = document.querySelector('[data-price-unit]');
  var atcBase = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';

  // a price that changes gets a quick pop so the change is noticed
  function setText(el, text) {
    if (!el || el.textContent === text) return;
    el.textContent = text;
    el.classList.remove('is-pop');
    void el.offsetWidth;
    el.classList.add('is-pop');
  }

  // pull the currency symbol out of the price Shopify already rendered, so
  // totals format correctly whatever currency the store is in
  var sample = priceNow ? priceNow.textContent.trim() : '';
  var symbol = sample.replace(/[\d.,\s]/g, '');

  function money(cents) {
    if (!cents && cents !== 0) return '';
    return symbol + (cents / 100).toFixed(2);
  }

  function subOn() {
    return !!(subToggle && subToggle.checked && planInput && planInput.getAttribute('data-plan-id'));
  }

  // Refills checked: cards show the subscription price (the Appstle plan's
  // discount off the variant price). Unchecked: the one-time variant price.
  // Savings are always measured against the compare-at price.
  function tierPrice(opt) {
    var one = parseInt(opt.getAttribute('data-price'), 10) || 0;
    var sub = parseInt(opt.getAttribute('data-sub'), 10) || 0;
    return subOn() && sub > 0 ? sub : one;
  }

  function paintOption(opt) {
    var now = tierPrice(opt);
    var was = parseInt(opt.getAttribute('data-compare'), 10) || 0;
    var nowEl = opt.querySelector('[data-bnd-now]');
    var saveEl = opt.querySelector('[data-bnd-save]');
    var cans = parseInt(opt.getAttribute('data-cans'), 10) || 0;
    var unitEl = opt.querySelector('[data-bnd-unit]');
    setText(nowEl, money(now));
    if (unitEl && cans > 0) unitEl.textContent = money(Math.round(now / cans));
    if (saveEl) {
      var pct = was > now ? Math.round((was - now) / was * 100) : 0;
      saveEl.textContent = pct > 0 ? 'You save ' + pct + '%' : '';
    }
  }

  function current() {
    for (var i = 0; i < opts.length; i++) {
      var r = opts[i].querySelector('input[type="radio"]');
      if (r && r.checked) return opts[i];
    }
    return opts[0] || null;
  }

  function sync() {
    opts.forEach(function (o) {
      paintOption(o);
      var r = o.querySelector('input[type="radio"]');
      o.classList.toggle('is-selected', !!(r && r.checked));
    });
    var opt = current();
    if (!opt) return;

    var packs = parseInt(opt.getAttribute('data-packs'), 10) || 1;
    var cans = parseInt(opt.getAttribute('data-cans'), 10) || 0;
    var qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
    var now = tierPrice(opt);
    var was = parseInt(opt.getAttribute('data-compare'), 10) || 0;

    if (variantInput) variantInput.value = opt.getAttribute('data-variant');
    if (qtyInput) qtyInput.value = qty;
    if (planInput) planInput.value = subOn() ? planInput.getAttribute('data-plan-id') : '';

    setText(priceNow, money(now));
    if (priceUnit && cans > 0) priceUnit.textContent = cans + ' cans, ' + money(Math.round(now / cans)) + ' a can';
    if (priceWas) { priceWas.textContent = money(was); priceWas.style.display = was > now ? '' : 'none'; }
    if (priceSave) {
      var pct = was > now ? Math.round((was - now) / was * 100) : 0;
      priceSave.textContent = 'Save ' + pct + '%';
      priceSave.style.display = pct > 0 ? '' : 'none';
    }
    if (atcLabel) atcLabel.textContent = atcBase + ' \u00b7 ' + money(now);
    if (stickyPack) stickyPack.textContent = packs + (packs > 1 ? ' packs' : ' pack') + (cans ? ', ' + cans + ' cans' : '') + (subOn() ? ', refills' : '');
    if (stickyPrice) stickyPrice.textContent = money(now);
    if (subToggle) {
      var box = subToggle.closest('[data-bnd-sub]');
      if (box) box.classList.toggle('is-on', subToggle.checked);
    }
  }

  opts.forEach(function (o) {
    var r = o.querySelector('input[type="radio"]');
    if (r) r.addEventListener('change', sync);
  });
  if (subToggle) subToggle.addEventListener('change', sync);
  if (opts.length) sync();

  /* ---------- sticky add to cart ---------- */
  var sticky = document.querySelector('[data-sticky]');
  var stickyAdd = document.querySelector('[data-sticky-add]');

  if (stickyAdd && form) {
    stickyAdd.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  if (sticky && form && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) sticky.removeAttribute('data-show');
        else if (entry.boundingClientRect.top < 0) sticky.setAttribute('data-show', '');
        else sticky.removeAttribute('data-show');
      });
    }, { threshold: 0 });
    io.observe(form);
  }

  /* ---------- header: denser glass once the page moves ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var stuck = false;
    var onScroll = function () {
      var next = window.scrollY > 8;
      if (next !== stuck) { stuck = next; header.classList.toggle('is-stuck', stuck); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // daylight glass while a morning section sits under the header
    if ('IntersectionObserver' in window) {
      var dayZones = document.querySelectorAll('.day-bg');
      if (dayZones.length) {
        var under = [];
        var hio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var at = under.indexOf(e.target);
            if (e.isIntersecting && at < 0) under.push(e.target);
            if (!e.isIntersecting && at > -1) under.splice(at, 1);
          });
          header.classList.toggle('is-day', under.length > 0);
          document.documentElement.classList.toggle('sky-rest', under.length > 0);
        }, { rootMargin: '-30px 0px -96% 0px' });
        dayZones.forEach(function (z) { hio.observe(z); });
      }
    }
  }

  /* ---------- menu drawer ---------- */
  var nav = document.querySelector('[data-nav-drawer]');
  var navLast = null;

  function navOpen() {
    if (!nav || nav.classList.contains('is-open')) return;
    navLast = document.activeElement;
    nav.setAttribute('aria-hidden', 'false');
    void nav.offsetWidth; // commit the off-screen start position so it slides
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        nav.classList.add('is-open');
        document.documentElement.classList.add('nd-lock');
      });
    });
    var btn = nav.querySelector('[data-nav-close]');
    if (btn && btn.focus) setTimeout(function () { btn.focus(); }, 380);
    var opener = document.querySelector('[data-nav-open]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }

  function navClose() {
    if (!nav) return;
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nd-lock');
    var opener = document.querySelector('[data-nav-open]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (navLast && navLast.focus) navLast.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) {
      e.preventDefault();
      navOpen();
      return;
    }
    if (e.target.closest('[data-nav-close]')) {
      e.preventDefault();
      navClose();
      return;
    }
    // a menu link that jumps within this page should close the drawer first
    var link = e.target.closest('.nd__nav a');
    if (link && nav && nav.classList.contains('is-open')) {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('#') > -1) navClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) navClose();
  });

  /* ---------- honeypot: catches naive bots without a captcha ---------- */
  var contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    var loadedAt = Date.now();
    contactForm.addEventListener('submit', function (e) {
      var trap = contactForm.querySelector('[name="contact[website]"]');
      // a filled hidden field, or a submit within 3 seconds of the page loading,
      // is a bot rather than someone who actually typed a message
      if ((trap && trap.value) || Date.now() - loadedAt < 3000) e.preventDefault();
    });
  }

  /* ---------- contact modal ---------- */
  var cm = document.querySelector('[data-contact-modal]');
  var cmLast = null;

  function cmOpen() {
    if (!cm || cm.classList.contains('is-open')) return;
    cmLast = document.activeElement;
    cm.setAttribute('aria-hidden', 'false');
    void cm.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        cm.classList.add('is-open');
        document.documentElement.classList.add('cm-lock');
      });
    });
    var first = cm.querySelector('input[name="contact[name]"]');
    if (first && first.focus) setTimeout(function () { first.focus(); }, 340);
  }

  function cmClose() {
    if (!cm) return;
    cm.classList.remove('is-open');
    cm.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cm-lock');
    if (cmLast && cmLast.focus) cmLast.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-contact-open]')) {
      e.preventDefault();
      // if it was opened from the menu drawer, close that first
      var drawer = document.querySelector('[data-nav-drawer]');
      if (drawer && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('nd-lock');
      }
      cmOpen();
      return;
    }
    if (e.target.closest('[data-contact-close]')) {
      e.preventDefault();
      cmClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cm && cm.classList.contains('is-open')) cmClose();
  });

  // Shopify reloads the page after a contact form post, so reopen the modal
  // to show the success message rather than dropping the customer at the top
  if (cm && (window.CE_CONTACT_POSTED || window.location.search.indexOf('contact_posted=true') > -1)) {
    cmOpen();
  }

  /* ---------- smooth anchors ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    // scrollIntoView honours each target's CSS scroll-margin-top, so #buy
    // lands just under the thumbnails with the price and packs in view
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
